import { ReactElement } from 'react';
import { useTranslate } from '@client/i18n/hooks';
import { ModalButtons } from 'b2b-components/core/components/Modal';
import { Modal, MODAL_TYPE } from 'b2b-components/theme/components/Modal';
import { Props } from './NavigationPromptModal.types';

export const NavigationPromptModal = ({
  isOpen,
  onNavigationCancel,
  onNavigationConfirm,
}: Props): ReactElement => {
  const t = useTranslate();

  return (
    <Modal
      title={t('Leave the page?')}
      content={() => (
        <>
          {t('If you leave the page, all data entered in the form will be lost.')}
          <ModalButtons
            primary={{
              onClick: onNavigationCancel,
              label: t('Back'),
            }}
            secondary={{
              onClick: onNavigationConfirm,
              label: t('Yes, leave the form'),
            }}
          />
        </>
      )}
      isOpen={isOpen}
      onCloseModal={onNavigationCancel}
      type={MODAL_TYPE.small}
    />
  );
};
